//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
/**
 * Created by z003f2zh on 29.07.2015.
 */

(function () {

    'use strict';

    angular.module('container.layout')
        .directive('srsngFooter', srsngFooter);

    function srsngFooter() {
        return {
            restrict: 'E',
            scope: {},
            templateUrl: 'container/ui/app/layout/footer/footer.html',
            controller: controller
        };

        function controller($scope) {
            $scope.currentYear = new Date().getFullYear();
        }
    }

}());
